﻿import { IHashData } from "../IHashData";
import { IPage } from "../IPage";
import { MainSite } from "../MainSite";

export class SupportPage implements IPage {

    constructor(private mainSite: MainSite) {
    }

    public id: string = 'support';

    public initialize(): void {

    }

    private container: JQuery = null;


    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                this.render();
            }
            return true;
        } else {
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }
    
    public render(): void {
        this.container = $('<div class="container"></div>').appendTo('body');
        
        var pageBack = $('<div class="midi_common_link midi_supportPage_backLink">Back</div>')
            .appendTo(this.container)
            .click(() => {
                if (this.container) {
                    this.container.remove();
                    this.container = null;
                }
                window.history.back();
            });

        $('<div class="list-group midi_supportPage_list-group"></div>')
            .append($('<a href="#midi-support-section-navBar" class="midi-scroll-to list-group-item">Navigation Bar</a>'))
            .append($('<a href="#midi-support-section-mapPage" class="midi-scroll-to list-group-item">Map Page</a>'))
            .append($('<a href="#midi-support-section-tablePage" class="midi-scroll-to list-group-item">Table Page</a>'))
            .append($('<a href="#midi-support-section-plotPage" class="midi-scroll-to list-group-item">Plot Page</a>'))
            .append($('<a href="#midi-support-section-stationPage" class="midi-scroll-to list-group-item">Station Page</a>'))
            .append($('<a href="#midi-support-section-dataDisplays" class="midi-scroll-to list-group-item">Data Displays</a>'))
            .append($('<a href="#midi-support-section-glossary" class="midi-scroll-to list-group-item">Glossary</a>'))
            .appendTo(this.container);
        
        let container = $('<div class="midi_supportPage_content"></div>')
            .appendTo(this.container);

        $('<h1>Support</h1>').appendTo(container);

        var regionalAdminLink = MainSite.instance
            .setupRegionalAdminPopover($('<strong>Regional Administrator</strong>').
                css("cursor", "pointer"));

        $(`<p>This page describes the main features and functionality of this website. You can use the panel on the left to 
scroll to the section you are interested in.
</p>`)
            .appendTo(container)

        $('<p></p>').appendTo(container)
            .append($('<span>If you experience any problems with this website, or have any questions which are not answered on this page, then please contact your </span>')
                    .append(regionalAdminLink)
                    .append('.'));

        //---------Nav bar---------//
        $('<div id="midi-support-section-navBar" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Navigation Bar</h3>'))
            .append($(`<p>You can access the <a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a>,
<a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> and 
<a href="#midi-support-section-plotPage" class="midi-scroll-to">Plot</a> pages from the navigation bar at the top of the window.
The page that is currently selected is highlighted in <span class="midi_supportPage_yellow">yellow</span>.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/mainnavbar.png">
<figcaption>The main navigation bar.</figcaption>
</figure>`))
            .append($(`<p>The navigation bar also includes the 
<a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a>, 
<a href="#midi-support-section-stationSelector" class="midi-scroll-to">Station selector</a>,
<a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">Warning rules selector</a> and the 
<a href="#midi-support-section-userMenu" class="midi-scroll-to">User menu</a>. If the <strong>North Sea</strong>
region is selected, links to <a href="https://offshore.meteogroup.com/ocw/">METCAST</a> and
<a href="https://www.helimet.com/">HELIMET</a> are also shown.</p>`))
            .append($('<h5 id="midi-support-section-regionSelector">Region selector</h5>'))
            .append($(`<p>The region selector can be found next to the 
<a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a> page tab in the navigation bar. 
The region that is currently selected is displayed in the navigation bar itself and clicking
on the region label brings up a drop-down list of the other regions that are available to the user. 
Note that not all users will have access to all regions.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/regionselector.png">
<figcaption>The region selector drop-down.</figcaption>
</figure>`))
            .append($(`<p>Selecting a region changes the stations that are available in the 
<a href="#midi-support-section-stationSelector" class="midi-scroll-to">Station selector</a></strong> - 
only stations that are in the selected region are available. It also changes the region that is shown on the
<a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a> page as well as limits the data that is shown 
on the <a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> and 
<a href="#midi-support-section-plotPage" class="midi-scroll-to">Plot</a> pages to stations within the selected region.
</p>`))
            .append($('<h5 id="midi-support-section-stationSelector">Station selector</h5>'))
            .append($(`<p>The station selector can be found next to the 
<a href="#midi-support-section-plotPage" class="midi-scroll-to">Plot</a> page tab in the navigation bar. Clicking 
on the <strong>Station</strong> tab opens the station drop-down.
The stations that are listed in the station selector are dependent on the region that is selected in the 
<a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a> - only stations 
that are in the selected region are displayed. Clicking on a station in the drop-down opens the 
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page for the selected station.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/stationselector.png">
<figcaption>The station selector drop-down.</figcaption>
</figure>`))
            .append($('<h5 id="midi-support-section-warningRulesSelector">Warning rules selector</h5>'))
            .append($(`<p>The warning rules selector is found on the right-hand side of the navigation bar, 
next to the <a href="#midi-support-section-userMenu" class="midi-scroll-to">User menu</a> tab.</p>`))
            .append($(`<p>The user has the option of selecting between <strong>Aviation</strong> and <strong>Marine</strong>
warning rule sets and the rule set that is currently selected in always displayed in the navigation bar. Clicking on the rule
set label brings up the warning rules selector.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/warningrulesselector.png">
<figcaption>The warning rules selector drop-down.</figcaption>
</figure>`))
            .append($(`<p>The selected warning rule set modifies the thresholds at which warnings are displayed in the 
data boxes (i.e. the highlighting of the data values), as described in the
<a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section of this guide.</p>`))
            .append($(`<p>Clicking on the <i class="fa fa-info-circle" style="color: #2895F1"></i>
<span class="sr-only">i</span> icon in the warning selector drop-down shows the colour-coding rules that are applied to the
displayed data values.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/aviationwarningrules.png">
<figcaption>Colour-coding for the <strong>Aviation</strong> warning rule set.</figcaption>
</figure>`))
            .append($('<h5 id="midi-support-section-userMenu">User menu</h5>'))
            .append($(`<p>The user menu button is found at the right-hand side of the navigation bar, next to the 
<a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">Warning rules selector</a>. The username of the currently
logged in user is always displayed and clicking on the username opens the menu. Note that depending on your permission level,
this menu may display fewer options.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/usermenu.png">
<figcaption>The user menu.</figcaption>
</figure>`))
            .append($(`<p>From this menu, you can: 
<ul>
<li>log out of this website</li>
<li>change your password</li>
<li>access this guide from the <strong>support</strong> link</li>
<li>change the data display time between UTC, PC time or region/station time</li>
<li>switch to basic parameter view to show a subset of the available parameters on the 
<a href="#midi-support-section-basicParameterView" class="midi-scroll-to">Station</a> page</li>
<li>switch to night mode to dim the page for operation at night</li>
<li>access various other options if you have administrator privileges</li>
</ul>
</p>`))
            .append($('<h5>Small screens</h5>'))
            .append($(`<p>On small screens, the navigation bar collapses. All of the above functionality 
is maintained and each option that has been described is accessible by clicking on the 
<img src="images/supportpage/navigation/collapsednavbtn.png"> button on the
right-hand side.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/navigation/collapsednav.png">
<figcaption>The collapsed navigation bar on small screens.</figcaption>
</figure>`));

        //---------Map page---------//
        $('<div id="midi-support-section-mapPage" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Map Page</h3>'))
            .append($(`<p>The map page is accessible by clicking on the <strong>Map</strong> tab in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. It shows a map of the selected region which can 
be changed using the <a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a>. The stations within
the selected region are displayed as an overlay on the map.
</p>`))
            .append($(`<p>Clicking on a station on the map page opens the 
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page for the selected station. Hovering over the
station with the cursor opens the <a href="#midi-support-section-stationPopup" class="midi-scroll-to">Latest observations pop-up</a>
for the selected station. By default, the station name is displayed in the label next to the circle that represents the station 
on the map. This label can show different station information, depending on what is selected in the 
<a href="#midi-support-section-stationLabelsSelector" class="midi-scroll-to">Station labels selector</a>.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/mappage.png">
<figcaption>A snippet of the map page showing some stations for the <strong>North Sea</strong> region.</figcaption>
</figure>`))
            .append($('<h5 id="midi-support-section-stationPopup">Latest observations pop-up</h5>'))
            .append($(`<p>Hovering over a station on the map page displays the latest observations pop-up for the 
station of interest. Data for a number of parameters are available in this pop-up, in the format described in
the <a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section of this guide. If a data value 
exceeds any of the warning thresholds for the currently selected warning rule set 
(see <a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">this section</a> of the guide) then the corresponding 
box will be coloured appropriately.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/latestobservationspopup.png">
<figcaption>An example of the latest observations popup showing a warning for <strong>Wind Spd</strong>.</figcaption>
</figure>`))
            .append($('<h5 id="midi-support-section-stationLabelsSelector">Station labels selector</h5>'))
            .append($(`<p>The station labels selector is shown on the right-hand side of the map page. Clicking on this 
button shows a drop-down that you can use to include the current value for a parameter, as well as the station name,
in the label that is shown next to each station on the map. For a full description of the parameters that are available,
please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of this guide.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/stationlabelselector.png">
<figcaption>The station labels selector.</figcaption>
</figure>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/map/windstationlabels.png">
<figcaption>An example of station labels that include the <strong>Wind Spd</strong> parameter.</figcaption>
</figure>`));

        //-------Table Page-------//
        $('<div id="midi-support-section-tablePage" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Table Page</h3>'))
            .append($(`<p>The table page is accessible by clicking on the <strong>Table</strong> tab in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. It shows a table containing key parameter values 
for all of the stations in the selected region, which can 
be changed using the <a href="#midi-support-section-regionSelector" class="midi-scroll-to">Region selector</a>. For a full
list of all of the parameters, please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of this guide.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/table/tablepage.png">
<figcaption>A snippet of the table page for the <strong>North Sea</strong> region, showing warnings for 
some of the <strong>Wind Spd</strong> values.</figcaption>
</figure>`))
                .append($(`<p>The data in each of the table cells is formatted as described in
the <a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section of this guide. If a data value 
exceeds any of the warning thresholds for the currently selected warning rule set 
(see <a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">this section</a> of the guide) then the corresponding 
cell will be coloured appropriately.</p>`))
                .append($(`<p>Clicking on the station name will open the 
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page for the selected station. Clicking on
one of the table cells that show data will open the
<a href="#midi-support-section-parameterpopup" class="midi-scroll-to">Parameter pop-up</a> for the selected parameter.</p>`))
            .append($(`<p>The <strong>Obs. Time</strong> column shows the time that the last data was received for a particular 
station.</p>`))
                .append($('<h5 id="midi-support-section-parameterpopup">Parameter pop-up</h5>'))
                .append($(`<p>The parameter pop-up shows a chart of recent data for the selected parameter for the 
selected station. This is the same pop-up as is shown when clicking on a data value on the
<a href="#midi-support-section-stationPage" class="midi-scroll-to">Station</a> page.</p>`))
                .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/table/parameterpopup.png">
<figcaption>An example of a parameter pop-up which shows both 
<span class="midi_supportPage_historicalBlue">historical</span> and  
<span class="midi_supportPage_forecastBlack">forecast</span> data.</figcaption>
</figure>`))
            .append($(`<p>The main feature of the parameter pop-up is the chart at the bottom. This chart shows a 
snapshot of the <span class="midi_supportPage_historicalBlue">historical</span> data for the selected parameter. The 
chart may also show <span class="midi_supportPage_forecastBlack">forecast</span> data, depending on the selected site/parameter.
</p>
<p>Users can change the time period of the chart to 12 hours, 24 hours, 2 days, 7 days or 30 days by using the 
buttons above the chart. Note that if both forecast and historical data are shown, selecting the time period using
these buttons will show that time period for both the forecast and historical components of the chart. For example,
selecting 12 hours will show 12 hours of historical data and 12 hours of forecast data.
The time period can also be changed by dragging the highlighted section of the navigator which sits below the main chart.
</p>`))
            .append($(`<p>The top section of the pop-up shows the name of the station, an abbreviation of the 
parameter name, the units, the time at which the latest data was received, a description of the
parameter and the name of the sensor for the data that is displayed in the chart.</p>`))
            .append($(`<p>The grouping section of the pop-up allows the user to select between 
<strong>High</strong>, <strong>Average</strong> and <strong>Low</strong> data grouping for the data that is shown
on the chart. Please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of
this guide for a description of data grouping.</p>`));

        //--------Plot Page ------//
        $('<div id="midi-support-section-plotPage" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Plot Page</h3>'))
            .append($(`<p>The plot page is accessible by clicking on the <strong>Plot</strong> tab in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. It allows users to generate plots of 
historical data for any of the plottable parameters of the stations within the selected region. By default, 
the last 30 days of data for the selected parameters is shown.</p>
<p>This page consists of the
<a href="#midi-support-section-plotNavBar" class="midi-scroll-to">plotting navigation bar</a>, the 
<a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">parameter select tree</a>, the 
<a href="#midi-support-section-plotParamSet" class="midi-scroll-to">parameter sets pane</a> and the main plotting area. 
Users manipulate what is shown in the plotting area by selecting parameters/parameter sets and selecting options in the 
<a href="#midi-support-section-plotNavBar" class="midi-scroll-to">plotting navigation bar</a>.
</p>`))
            .append($(`<p>Below the plot is a navigator that users can use to scroll to a particular time period. 
There is also a legend, the label of which takes the form <strong>Region_Station.Sensor.Parameter/Units</strong>. There is no
limit to the number of parameters that can be displayed on the plot.</p>`))
            .append($(`<p>On mouseover, tooltips are displayed that show the value for each parameter displayed
in the chart at the given timestamp. The tooltip label uses the same format as the chart legend.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/exampleplot.png">
<figcaption>An example of a plot showing data for 4 parameters. Tooltips are displayed on mouseover
which show the data values for each parameter at a given timestamp.</figcaption>
</figure>`))
            .append($('<h5 id="midi-support-section-plotNavBar">Plotting navigation bar</h5>'))
            .append($(`<p>The plotting navigation bar contains a number of buttons that allow the user to 
modify the data that is shown in the chart as well as 
<a href="#midi-support-section-plotNavDataDownload" class="midi-scroll-to">download</a> the data that is currently
displayed. Note that on small screens the plotting navigation bar collapses as with the main
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation bar</a>. When collapsed, clicking the 
<img src="images/supportpage/navigation/collapsednavbtn.png"> button shows all of the options described below in a drop-down
list.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/plottingnavbar.png">
<figcaption>The plotting navigation bar.</figcaption>
</figure>`))
            .append($('<h6 id="midi-support-section-plotNavTimePeriod">Changing time period</h6>'))
            .append($(`<p>Users can quickly change the time period shown on the plot to 24 hours, 
7 days, 14 days, 30 days or 90 days by clicking on the corresponding button. 
If one of these time periods is selected, it is highlighted in <span class="midi_supportPage_yellow">yellow</span> 
and the dates displayed in the date select boxes are updated. Users can also set a specific date range for 
the chart by clicking the date select boxes and manually choosing a start and end date. 
Note that the chart will show data from 00:00 on the start date until 23:59 on the end date.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/plotnavdateselect.png">
<figcaption>The date selector in the plotting navigation bar. The user is in the process of choosing a start date.
</figcaption>
</figure>`))
            .append($('<h6>Data grouping</h6>'))
            .append($(`<p>The grouping section of the plotting navigation bar allows the user to select between 
<strong>High</strong>, <strong>Average</strong> and <strong>Low</strong> data grouping for the data that is shown
on the chart. Please see the <a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> section of
this guide for a description of data grouping.</p>`))
            .append($('<h6>Function</h6>'))
            .append($(`<p>The function section of the plotting navigation bar allows the user to select between 
<strong>None</strong> and <strong>RoC</strong> functions. If <strong>None</strong> is selected then the default
time-series data is shown. If <strong>RoC</strong> is selected, then the <em>rate of change</em> of the data values per 
hour are displayed instead. This allows the user to see where the data is changing quickly over a short space of time.
</p>`))
            .append($('<h6>Stacked plots</h6>'))
            .append($(`<p>Clicking the <img src="images/supportpage/plot/stackedplotsbtn.png">
button toggles the plot display from grouped to stacked. The plots are stacked if this button is 
highlighted <span class="midi_supportPage_yellow">yellow</span>. 
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/stackedplots.png">
<figcaption>An example of stacked plots.
</figcaption>
</figure>`))
            .append($('<h6 id="midi-support-section-plotNavDataDownload">Downloading data</h6>'))
            .append($(`<p>One click snap-shots of the data displayed in the plot 
can be downloaded in either CSV or Shell DLP file formats by clicking 
the corresponding button on the right-hand side of the plotting navigation bar. There is also the option to save an 
image of the plot in PNG format.</p>`))
            .append($('<h5 id="midi-support-section-plotParamSelect">Parameter select tree</h5>'))
            .append($(`<p>The parameter select tree sits on the right-hand side of the plotting page. 
First, the user clicks a station name to expand a list of sensors for that station. Clicking on a sensor shows a list of all of the 
plottable parameters that the selected sensor collects data for. Clicking on a parameter label toggles whether or not that parameter 
is shown on the plot. Note that not all parameters are plottable but data for these parameters can still be downloaded using the 
<a href="#midi-support-section-plotParamSetDownload" class="midi-scroll-to">Data download</a> feature.
</p>
<p>
There is no limit to the number of these plottable parameters that the user can choose to show on the plot and those that 
are currently selected are highlighted <span class="midi_supportPage_yellow">yellow</span>.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/parameterselecttree.png">
<figcaption>A snippet of the parameter select tree with 2 selected parameters.
</figcaption>
</figure>`))
            .append($(`<p>
The width of the parameter select tree can be increased by clicking and dragging the left-hand side of the box that it sits in - the 
mouse cursor will change to a double headed arrow. Increasing the width of this box 
also increases the width of the <a href="#midi-support-section-plotParamSet" class="midi-scroll-to">Parameter sets pane</a>
and decreases the width of the plot.
</p>`))
            .append($(`<p>
Users may wish to save the selected parameters as a <strong>parameter set</strong> so that they can readily plot the same parameters 
again when they next come to the plotting page. Parameter sets can be saved by clicking the <strong>Save Set</strong> button at the top 
of the parameter select tree. In the pop-up that appears, users must either enter a name for the parameter set 
if they would like to create a new one or choose from a list of existing parameter sets to overwrite an 
existing set. Clicking the <strong>Save</strong> button saves the parameter set and saved parameter sets are displayed in the 
<a href="#midi-support-section-plotParamSet" class="midi-scroll-to">Parameter sets pane</a>.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/saveparamset.png">
<figcaption>The pop-up that appears when the user clicks the <strong>Save Set</strong> button to save a 
new parameter set or overwrite an existing set.
</figcaption>
</figure>`))
            .append($('<h6 id="midi-support-section-plotParamSetDownload">Data download</h6>'))
            .append($(`<p>Data from an individual station can be download by clicking the 
<img src="/images/icons/download.png" style="height: 16px; width: 16px"></img> icon next to the station name in the 
tree. Clicking this button brings up the download data pop-up.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/datadownload.png">
<figcaption>The data download pop-up with all temperature parameters selected and some wave parameters selected for the station 
<strong>Nelson</strong>.
</figcaption>
</figure>`))
            .append($(`<p>The data download pop-up allows the user to specify a data interval and time period for the data
they wish to download. Users can download data in either CSV or Shell DLP format and can select between downloading all data for the 
selected station or a sub-set of the data, which may include non-plottable parameters.</p>`))
            .append($('<h5 id="midi-support-section-plotParamSet">Parameter sets pane</h5>'))
            .append($(`<p>This pane shows the parameter sets that the user has created using the 
<a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">Parameter select tree</a> and allows users to
easily reproduce charts for parameters of interest without selecting them individually from the tree.</p>`))
            .append($(`<p>Clicking the name of the parameter set automatically selects the parameters 
within the <a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">Parameter select tree</a> and shows
the latest data for these parameters on the chart. Clicking <strong>None</strong> de-selects all currently selected parameters.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/plot/parametersets.png">
<figcaption>The parameter sets pane.
</figcaption>
</figure>`))
            .append($(`<p>Users can delete a parameter set by clicking the <i class="fa fa-trash-o"></i> 
button next to the name of the parameter set and clicking <strong>Delete</strong> in the pop-up that appears.</p>`))
            .append($(`<p>
The width of the parameter sets pane can be increased by clicking and dragging the left-hand side 
of the box that it sits in - the  mouse cursor will change to a double headed arrow. Increasing the width of this box 
also increases the width of the 
<a href="#midi-support-section-plotParamSelect" class="midi-scroll-to">Parameter select tree</a>
and decreases the width of the plot.
</p>`))

        //----------Station Page ------//
        $('<div id="midi-support-section-stationPage" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Station Page</h3>'))
            .append($(`<p>The station page shows a full data display for the selected station and can be accessed either 
by clicking on the station of interest on the <a href="#midi-support-section-mapPage" class="midi-scroll-to">Map</a> page,
clicking on the station name on the <a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> page or
clicking on the station name in the <a href="#midi-support-section-stationSelector" class="midi-scroll-to">Station selector</a>.
The name of the selected station is highlighted in <span class="midi_supportPage_yellow">yellow</span> in the 
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation Bar</a>.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/stationpage.png">
<figcaption>An example of the <a href="#midi-support-section-overviewTab" class="midi-scroll-to">Overview</a> 
station page with a <span class="midi_supportPage_yellow">yellow</span> warning for <strong>Wind Spd</strong>.
</figcaption>
</figure>`))
            .append($(`<p>The top left of this page shows the timestamp that data was last received for the selected station.
Depending on the station that has been selected, and the number of available sensors/parameters, this page may contain more than 
one tab. The tabs that are available sit at the top of the page next to the timestamp. A brief description of each of the tabs that might be present 
for a given site is provided in this section and the selected tab is highlighted <span class="midi_supportPage_yellow">yellow</span>.
</p>`))
            .append($(`<p>The majority of the data present on each tab is presented as a series of parameter boxes. The formatting 
of the data is described in the <a href="#midi-support-section-dataDisplays" class="midi-scroll-to">Data Displays</a> section. 
If the data in these boxes exceeds the relevant warning rules, as described in 
<a href="#midi-support-section-warningRulesSelector" class="midi-scroll-to">this section</a> of the guide, the background colour 
of the box will reflect the warning level.</p><p>Hovering over a parameter box shows the latest  timestamp that data for that 
parameter was received.
Clicking on a parameter box opens a pop-up plot which is the same as is described in the 
<a href="#midi-support-section-parameterpopup" class="midi-scroll-to">Parameter pop-up</a> section of this guide, as part of the 
<a href="#midi-support-section-tablePage" class="midi-scroll-to">Table</a> section. Note that not all of the parameters shown 
on the station page are plottable, in which case the parameter pop-up will show the text <em>this parameter is not plottable</em>.
</p>`))
            .append($(`<p>Note that a description of each of the parameters is provided in the 
<a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a>.
</p>`))
            .append($('<h5 id="midi-support-section-overviewTab">Overview tab</h5>'))
            .append($(`<p>If a station has more than one sensor then the overview tab will be available. This tab will 
be open by default and will show:
<ul>
<li>The wind compass (see the <a href="#midi-support-section-windCompass" class="midi-scroll-to">Wind compass</a> section below)</li>
<li>Vessel heading (if the station is a vessel)</li>
<li>Helideck status information (if the station has helidecks)</li>
<li>Wind direction, variation, speed and gust speed</li>
<li>Cloud information including the cloud cover (amount) and height of up to 3 cloud layers</li>
<li>Visibility</li>
<li>METAR</li>
</ul>
</p>`))
            .append($('<h5 id="midi-support-section-cloudsTab">Clouds tab</h5>'))
            .append($(`<p>If a station has more than one sensor or if its only sensor is a cloud sensor then the 
clouds tab will be available. If the station has only a single cloud sensor then this tab is opened by default.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/cloudstab.png">
<figcaption>An example the clouds station page.
</figcaption>
</figure>`))
            .append($(`<p>
At the top of this page is a timeseries plot of <span class="midi_supportPage_cloudsRed">visibility</span> and 
<span class="midi_supportPage_cloudsGrey">instantaneous cloud height</span>. This page also shows:
<ul>
<li>The cloud cover and height of up to 3 cloud layers</li>
<li>The instantaneous cloud height of up to 3 cloud layers</li>
<li>Visibility</li>
<li>Present weather as METAR</li>
<li>Rainfall intensity</li>
<li>Solar radiation</li>
</ul>
</p>`))
            .append($('<h5 id="midi-support-section-wavesTab">Waves tab</h5>'))
            .append($(`<p>If a station has more than one sensor or if its only sensor is a sensor that records <strong>Hs</strong> 
then the waves tab will be available. If the station only has a single <strong>Hs</strong> sensor then this tab is opened by default.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/wavestab.png">
<figcaption>An example of the waves station page.
</figcaption>
</figure>`))
            .append($(`<p>
The right-hand side of this page may show a different chart, from a selection of the following, depending on if the wave sensor 
is directional or not:
<ul>
<li>a <span class="midi_supportPage_wavesBlue">wave spectrum</span> (default) chart which may also show 
<span class="midi_supportPage_cloudsRed">mean direction</span> and <span class="midi_supportPage_wavesPink">directional spread</span>
if the sensor is directional.</li>
<li>a polar chart of <strong>Hs</strong> versus mean direction if the wave sensor is directional. 
The user can choose the time period of this data from a selection of 1 day, 7 days, 30 days.</li>
<li>a directional wave spectrum rose (polar spectrum) if the wave sensor is directional. Each coloured segment corresponds to 
one frequency component from the directional wave spectrum. The direction of the segment corresponds to the mean direction 
of the component. The length of the segment corresponds to the spectral density of that component and the colour of the 
segment corresponds to the period of that component.</li>
</ul></p>`))
                .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/polarwaves.png">
<img src="images/supportpage/station/polarspectrumwaves.png">
<figcaption>An example of the polar charts that may also be available on the waves station page. The first chart represents 
<strong>Hs</strong> versus mean direction and the second is the directional wave spectrum rose.
</figcaption>
</figure>`))
            .append($(`<p>This page also shows parameter boxes for the following parameters (see the 
<a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> for a description of each of the parameters):
<ul>
<li>Buoy latitude and longitude (if the station is a buoy)</li>
<li>Buoy excursion (if the station is a buoy)</li>
<li>Mean WL (if the station is not a buoy)</li>
<li>Max TWL (if the station is not a buoy)</li>
<li>Hs and Hmax</li>
<li>Cmax and Cass</li>
<li>Tz, T2 and Tp</li>
<li>The radar air gap</li>
<li>Mean and peak wave directions as well as mean and peak spreads</li>
</ul>
</p>`))
            .append($('<h5 id="midi-support-section-currentTab">Current tab</h5>'))
            .append($(`<p>If a station has more than one sensor or if its only sensor is a current sensor 
then the current tab will be available. If the station only has a single current sensor then this tab is opened by default.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/currenttab.png">
<figcaption>An example of the current station page.
</figcaption>
</figure>`))
            .append($(`<p>
The right-hand side of this page may show a different chart, from a selection of the following, depending on if the station 
has a current sensor and, if so, the sensor measures bottom current or just surface current:
<ul>
<li>a current profile chart showing <span class="midi_supportPage_cloudsRed">speed</span> and 
<span class="midi_supportPage_currentGreen">direction</span> at different depths (requires an ADCP sensor)</li>
<li>a progressive vector diagram (pvd) chart which shows the path a floating particle would take if the 
currents were spatially uniform (and the floating particle was not directly influenced by wind and waves). 
This chart is based on <em>surface</em> current speed and direction and uses historical data, not just the latest record.
The user can choose the time period of this data from a selection of 1 day, 7 days, 30 days.</li>
<li>a polar chart of surface current speed versus mean direction. 
The user can choose the time period of this data from a selection of 1 day, 7 days, 30 days.</li>
</ul></p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/pvdchart.png">
<img src="images/supportpage/station/polarcurrent.png">
<figcaption>An example of the two other charts that may be displayed on the current page. The first is an example of a progressive
vector diagram (pvd) and the second is a polar chart for current.
</figcaption>
</figure>`))
            .append($(`<p>This page also shows parameter boxes for the following parameters:
<ul>
<li>Surface current direction and speed</li>
<li>Mid-depth current direction and speed (if the sensor measures more than surface current)</li>
<li>Bottom current direction and speed (if the sensor measures more than surface current)</li>
<li>Peak current direction and speed (if the sensor measures more than surface current)</li>
<li>Peak current depth (if the sensor measures more than surface current)</li>
</ul>
</p>`))
            .append($('<h5 id="midi-support-section-motionTab">Motion tab</h5>'))
            .append($(`<p>If a station has more than one sensor or if its only sensor is a motion sensor 
then the motion tab will be available. If the station only has a single motion sensor then this tab is opened by default.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/motiontab.png">
<figcaption>An example of the motion station page.
</figcaption>
</figure>`))
            .append($(`<p>This page shows parameter boxes for the following parameters (see the 
<a href="#midi-support-section-glossary" class="midi-scroll-to">Glossary</a> for a description of each parameter):
<ul>
<li>Maximum roll left and right</li>
<li>Excursion distance and bearing</li>
<li>Pitch bow up and pitch bow down</li>
<li>Heave rate, max heave and heave period</li>
<li>Motion severity parameters <strong>MMS</strong> and <strong>MSI</strong></li>
<li>Max inclination</li>
</ul>
</p>`))
            .append($('<h5 id="midi-support-section-windTab">Wind tab</h5>'))
            .append($(`<p>If a station has more than one sensor or if its only sensor is a wind sensor 
then the wind tab will be available. If the station only has a single wind sensor then this tab is opened by default.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/windtab.png">
<figcaption>An example of the wind station page.
</figcaption>
</figure>`))
            .append($(`<p>For each of the station's wind sensors, this page shows:
<ul>
<li>A <a href="#midi-support-section-windCompass" class="midi-scroll-to">Wind compass</a> or polar chart of wind speed versus 
mean wind direction (selectable at the top of the page)</li>
<li>1-minute and 10-minute mean wind direction</li>
<li>1-minute and 10-minute wind speed</li>
<li>1-minute and 10-minute gust speed</li>
</ul>
</p>`))
            .append($(`<p>At the bottom of the page is a chart showing 10-minute means of wind speed, direction and gust speed for 
each of the station's wind sensors.
</p>`))
            .append($('<h5 id="midi-support-section-motionTab">Risers tab</h5>'))
            .append($(`<p>This tab is currently only available for the station <strong>Malikai</strong> and shows the riser 
tension and tensioner pressures for the FPSO, as well as motion parameters.
</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/riserstab.png">
<figcaption>An example of Malikai's risers station page.
</figcaption>
</figure>`))
            .append($('<h5 id="midi-support-section-windCompass">Wind compass</h5>'))
            .append($(`<p>The wind compass is accessible from the 
<a href="#midi-support-section-overviewTab" class="midi-scroll-to">Overview tab</a> (if the station has more than one
sensor) or the <a href="#midi-support-section-windTab" class="midi-scroll-to">Wind tab</a>.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/windcompass.png">
<figcaption>The wind compass.
</figcaption>
</figure>`))
            .append($(`<p>In the centre of the compass, the name of the wind sensor is displayed as well as the numerical 
value for wind direction and speed. If the height of the wind sensor is known, this is also displayed in the centre of the
compass, following the <strong>@</strong> symbol.</p>`))
            .append($(`<p>On the outer ring of the compass, the green arrow represents the direction that the wind 
is coming from and the yellow block represents the variation in wind direction.</p>`))
            .append($('<h5 id="midi-support-section-basicParameterView">Basic parameter view</h5>'))
            .append($(`<p>If the user has selected to switch to basic parameter view from the 
<a href="#midi-support-section-userMenu" class="midi-scroll-to">User menu</a> section of the
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation Bar</a> then a reduced subset of the parameters
will be shown on the station's <a href="#midi-support-section-overviewTab" class="midi-scroll-to">Overview</a>
and <a href="#midi-support-section-wavesTab" class="midi-scroll-to">Wave</a> pages.</p>`))
            .append($(`<figure class="midi_supportPage_figure">
<img src="images/supportpage/station/stationpagebasic.png">
<figcaption>An example of the overview station page with basic parameter view.
</figcaption>
</figure>`));

        //------------Data displays -------//
        $('<div id="midi-support-section-dataDisplays" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Data Displays</h3>'))
            .append($(`<p>This section describes how the parameter values are displayed throughout this website.
</p>`))
            .append($('<h5>Parameter values</h5>'))
            .append($('<p>The value for a given parameter may be displayed in one of four ways:</p>'))
            .append($('<ul></ul>')
                .append('<li><span class="midi_supportPage_parameterValueKey">---</span>&nbsp;&nbsp;There is no instrument installed for the parameter</li>')
                .append('<li><span class="midi_supportPage_parameterValueKey">///</span>&nbsp;&nbsp;The parameter has been received in the past but there have been no new values in the last two hours</li>')
                .append('<li><span class="midi_supportPage_parameterValueKey midi_supportPage_parameterValueKey_oldData">23.4</span>&nbsp;&nbsp;The value is between one and two hours old</li>')
                .append('<li><span class="midi_supportPage_parameterValueKey">23.4</span>&nbsp;&nbsp;The value was received in the last hour</li>'))
            .append($('<h5 id=""midi-support-section-warningRules">Warning rules</h5>'))
            .append($(`<p>Value boxes are colour coded depending on the selected <strong>Warning Rules</strong>. 
These can be viewed or changed from the navigation bar, as described in the
<a href="#midi-support-section-navBar" class="midi-scroll-to">Navigation Bar</a> section.</p>`));

        $('<div id="midi-support-section-glossary" class="midi-support-section"></div>')
            .appendTo(container)
            .append($('<h3 class="page-header">Glossary</h3>'))
            .append($(`<p>This section provides a description of each of the parameters and 
parameter units displayed on this website as well as definitions for some of the more technical terms/abbreviations used.</p>`))
            .append($('<h5>Parameters</h5>'))
            .append($(`
<table class="table table-striped midi_common_table">
<thead>
<tr>
<th>Label</th>
<th>Definition</th>
</tr>
</thead>
<tbody>
<tr><th>Air Gap</th><td>Radar air gap (Mean)</td></tr>
<tr><th>Air Temp</th><td>Dry bulb air temperature</td></tr>
<tr><th>Bottom Current Spd</th><td>Bottom current speed</td></tr>
<tr><th>Btm. Current Dir.</th><td>Bottom current direction</td></tr>
<tr><th>Cass</th><td>Crest associated with the maximum wave height</td></tr>
<tr><th>Cloud Amt 1</th><td>The amount of sky obscured by clouds in the lowest cloud base</td></tr>
<tr><th>Cloud Amt 2</th><td>The amount of sky obscured by clouds in the second lowest cloud base</td></tr>
<tr><th>Cloud Amt 3</th><td>The amount of sky obscured by clouds in the third lowest cloud base</td></tr>
<tr><th>Cloud Ht 1</th><td>Height of lowest cloud base</td></tr>
<tr><th>Cloud Ht 1 Inst</th><td>Instantaneous height of lowest cloud base</td></tr>
<tr><th>Cloud Ht 2</th><td>Height of second lowest cloud base</td></tr>
<tr><th>Cloud Ht 2 Inst</th><td>Instantaneous height of second lowest cloud base</td></tr>
<tr><th>Cloud Ht 3</th><td>Height of third lowest cloud base</td></tr>
<tr><th>Cloud Ht 3 Inst</th><td>Instantaneous height of third lowest cloud base</td></tr>
<tr><th>Cmax</th><td>Maximum crest height</td></tr>
<tr><th>Dew Point</th><td>The temperature at which condensation occurs</td></tr>
<tr><th>Draft</th><td>Vessel draft</td></tr>
<tr><th>Excursion</th><td>Buoy excursion from target location</td></tr>
<tr><th>Excursion Bearing</th><td>Bearing of maximum excursion</td></tr>
<tr><th>Gust Spd</th><td>Maximum gust speed in recording interval</td></tr>
<tr><th>Gust Spd (1 min)</th><td>Maximum gust speed observed over 1 minute</td></tr>
<tr><th>Gust Spd (10 min)</th><td>Maximum gust speed observed over 10 minutes</td></tr>
<tr><th>Heading</th><td>Heading towards which bow of vessel is pointing</td></tr>
<tr><th>Heave</th><td>Vessel heave</td></tr>
<tr><th>Helideck Status</th><td>Helideck status based on station-specific wind speed and direction rules</td></tr>
<tr><th>Hmax</th><td>Maximum upcrossing individual wave height from time domain</td></tr>
<tr><th>Hs</th><td>Significant wave height</td></tr>
<tr><th>Humidity</th><td>Percentage of the maximum possible amount of water contained in the air</td></tr>
<tr><th>Latitude</th><td>Vessel or buoy latitude</td></tr>
<tr><th>Longitude</th><td>Vessel or buoy longitude</td></tr>
<tr><th>Max Excursion</th><td>Maximum excursion distance</td></tr>
<tr><th>Max Heave</th><td>Maximum magnitude of vertical displacement</td></tr>
<tr><th>Max Heave Rate</th><td>Maximum rate of vertical displacement</td></tr>
<tr><th>Max Inclination</th><td>Maximum angle of deck from normal</td></tr>
<tr><th>Max Pitch Bow Down</th><td>Maximum angle of rotation from vertical,  positive bow down</td></tr>
<tr><th>Max Pitch Bow Up</th><td>Maximum angle of rotation from vertical,  positive bow up</td></tr>
<tr><th>Max Roll Left</th><td>Maximum angle of rotation from vertical,  positive portside down</td></tr>
<tr><th>Max Roll Right</th><td>Maximum angle of rotation from vertical,  positive portside up</td></tr>
<tr><th>Max TWL</th><td>Maximum total water level</td></tr>
<tr><th>Mean Dir.</th><td>Average wave direction of the full spectrum</td></tr>
<tr><th>Mean Heave Period</th><td>Mean period of vertical displacement motion</td></tr>
<tr><th>Mean Spread</th><td>Average directional spreading of the full spectrum</td></tr>
<tr><th>Mean WL</th><td>Mean total water level</td></tr>
<tr><th>Mid. Current Dir.</th><td>Middle current direction</td></tr>
<tr><th>Mid. Current Spd</th><td>Middle current speed</td></tr>
<tr><th>Mid. Current Spd</th><td>Middle current speed</td></tr>
<tr><th>MMS</th><td>Measure of motion severity</td></tr>
<tr><th>MSI</th><td>Motion severity index</td></tr>
<tr><th>Peak Current Depth</th><td>Peak current depth</td></tr>
<tr><th>Peak Current Dir.</th><td>Peak current direction</td></tr>
<tr><th>Peak Current Spd</th><td>Peak current speed</td></tr>
<tr><th>Peak Dir.</th><td>Peak wave direction of the full spectrum</td></tr>
<tr><th>Peak Spread</th><td>Directional spreading of peak frequency</td></tr>
<tr><th>Pitch</th><td>Vessel pitch</td></tr>
<tr><th>Present Weather</th><td>Present Weather in METAR coding format</td></tr>
<tr><th>QFE</th><td>Barometric pressure adjusted to field elevation</td></tr>
<tr><th>QNH</th><td>Barometric pressure adjusted to sea level</td></tr>
<tr><th>Rainfall</th><td>Total rainfall in 1 hour</td></tr>
<tr><th>Roll</th><td>Vessel roll</td></tr>
<tr><th>Sfc. Current Dir.</th><td>Surface current direction</td></tr>
<tr><th>Sfc. Current Spd</th><td>Surface current speed</td></tr>
<tr><th>Solar Rad.</th><td>Solar radiation flux density</td></tr>
<tr><th>Spectrum</th><td>Wave spectrum</td></tr>
<tr><th>Surge Acceleration</th><td>Surge acceleration</td></tr>
<tr><th>Sway Acceleration</th><td>Sway acceleration</td></tr>
<tr><th>T2</th><td>Average wave period defined by SQRT(M0/M2) from frequency domain</td></tr>
<tr><th>Tp</th><td>Spectral peak period of the full spectrum</td></tr>
<tr><th>Tz</th><td>Mean zero-upcrossing wave period from time domain</td></tr>
<tr><th>Visibility</th><td>Distance that can be seen clearly</td></tr>
<tr><th>Wind Backed</th><td>Maximum counter-clockwise extent of wind variation</td></tr>
<tr><th>Wind Chill</th><td>The apparent temperature felt on exposed skin due to wind</td></tr>
<tr><th>Wind Dir.</th><td>Vector mean direction of wind velocity</td></tr>
<tr><th>Wind Dir. (1 min)</th><td>Vector mean direction of wind velocity over 1 minute</td></tr>
<tr><th>Wind Dir. (10 min)</th><td>Vector mean direction of wind velocity over 10 minutes</td></tr>
<tr><th>Wind Selected Sensor</th><td>The selected wind sensor</td></tr>
<tr><th>Wind Spd</th><td>Scalar mean speed of wind velocity</td></tr>
<tr><th>Wind Spd (1 min)</th><td>Vector mean speed of wind velocity over 1 minute</td></tr>
<tr><th>Wind Spd (10 min)</th><td>Vector mean speed of wind velocity over 10 minutes</td></tr>
<tr><th>Wind Veered</th><td>Maximum clockwise extent of wind variation</td></tr>
</tbody>
</table>
`))
        .append($('<h5>Units</h5>'))
            .append($(`
<table class="table table-striped midi_common_table">
<thead>
<tr>
<th>Label</th>
<th>Definition</th>
</tr>
</thead>
<tbody>
<tr><th>°C</th><td>Degrees Celsius</td></tr>
<tr><th>°T</th><td>Degrees True</td></tr>
<tr><th>ft</th><td>Feet</td></tr>
<tr><th>hPa</th><td>Hectopascals</td></tr>
<tr><th>kts</th><td>Knots</td></tr>
<tr><th>m</th><td>Metres</td></tr>
<tr><th>m/s</th><td>Metres per second</td></tr>
<tr><th>m/s²</th><td>Metres per second squared</td></tr>
<tr><th>mm / hour</th><td>Millimetres per hour</td></tr>
<tr><th>mps</th><td>Metres per second</td></tr>
<tr><th>mW/cm²</th><td>Milliwatts per square centimetre</td></tr>
<tr><th>s</th><td>Seconds</td></tr>
</tbody>
</table>
`))
            .append($('<h5>Other definitions</h5>'))
            .append($(`
<table class="table table-striped midi_common_table">
<thead>
<tr>
<th>Label</th>
<th>Definition</th>
</tr>
</thead>
<tbody>
<tr><th>Data grouping</th><td>Where there are too many points to comfortably display on a chart, data grouping replaces a
sequence of data points in a series with a single <strong>grouped</strong> point. The values of each
<strong>grouped</strong> point is calculated from the original values of every point used. Users can select between 
<strong>average</strong>, <strong>high</strong> and <strong>low</strong> grouping approximations, which determine 
which value from the original data is used to represent the group.</td></tr>
<tr><th>Obs. time</th><td>Observation time</td></tr>
<tr><th>Pvd</th><td>Progressive vector diagram</td></tr>
<tr><th>RoC</th><td>Rate of change</td></tr>

</tbody>
</table>
`))

        $(".midi-scroll-to").on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: ($(target).offset().top) - 70
            }, 1000);
        });
    }

}
    

